import {
  GET_LIST_TAISAN,
  GET_LIST_TAISAN_SUCCESS,
  GET_LIST_TAISAN_FAILURE,
} from "actions/DanhSachTaiSan/actionTypes";
const initialState = {
  List: [],
  TongBanGhi: 0,
  TongSoTienVay: 0,
  getListTaiSanLoading: false,
};
const getListTaiSan = (state, action) => ({
  ...state,
  getListTaiSanLoading: true,
});

const getListTaiSanSuccess = (state, action) => {
  // console.log(action.payload);
  return {
    ...state,
    List: action.payload.List,
    TongBanGhi: action.payload.TongBanGhi,
    TongSoTienVay: action.payload.TongSoTienVay,
    getListTaiSanLoading: false,
  };
};

const getListTaiSanFailed = (state, action) => ({
  ...state,
  List: [],
});
export const listTaiSanReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_TAISAN:
      return getListTaiSan(state, action);
    case GET_LIST_TAISAN_SUCCESS:
      //alert("tuty");
      return getListTaiSanSuccess(state, action);
    case GET_LIST_TAISAN_FAILURE:
      //alert('false')
      return getListTaiSanFailed(state, action);
    default:
      return state;
  }
};

export default listTaiSanReducer;
